import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

// Pages 
import Hotel from './pages/Hotel';
import Home from './pages/Home';
import BusinessSeries from './pages/BusinessSeries';
import Footer from './components/footer';
import Page404 from './pages/Page404';
import ContactPage from './pages/Contact';
import FAQ from './pages/FAQ';
import About from './pages/About';
import Customer from './pages/Customers';
import Guides from './pages/Guides';
import Privacy from './pages/Privacy';
import Travel from './pages/Travel';
import CarPage from './pages/Car';
import DemoPage from './pages/Demo';
import ExpenseManagement from './pages/ExpenseManagement';
import KCare from './pages/K_Care';
import ScrollToTop from './helper/scrollToTop';

const App = () => {
  return (
    <BrowserRouter>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hotel" element={<Hotel />} />
          <Route path="/business-series" element={<BusinessSeries />} />
          <Route path="/car" element={<CarPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/about" element={<About />} />
          <Route path="/customer" element={<Customer />} />
          <Route path="/guides" element={<Guides />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/k-care" element={<KCare />} />
          <Route path="/expense-management" element={<ExpenseManagement />} />
          <Route path="/demo" element={<DemoPage />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
        <Footer />
      </ScrollToTop>
    </BrowserRouter>
  );
};
export default App;